import type { NodeSize } from "./node";

export type FontFeature = "ss01" | "ss02";

export const FONT_SIZES = [
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "20",
  "24",
  "30",
  "32",
  "34",
  "36",
  "40",
  "48",
  "62",
] as const;

export type FontSize = (typeof FONT_SIZES)[number];

/**
 * TeX-like math styles. Large operators are drawn from a bigger glyph in
 * `displaystyle` and from the default one in `textstyle`.
 */
export type MathStyle = "textstyle" | "displaystyle";

/**
 * - `n-ary`, `integral` — large operators
 * - `alternate-glyph` — a stylistic alternate that applies in every math style
 */
export type SymbolFontMetric = "n-ary" | "integral" | "alternate-glyph";

export type SymbolFont = {
  fontSize?: FontSize;
  fontFeature?: FontFeature;
};

export type SymbolFontContext = {
  mathStyle: MathStyle;
  size: NodeSize;
};

export type SymbolFontMetricJson = Partial<
  Record<
    MathStyle,
    {
      fontFeature?: FontFeature;
      fontSize?: Record<NodeSize, FontSize>;
    }
  >
>;

/**
 * Symbol rendering for one typeface.
 *
 * `symbols` classifies — which metric each key uses — and holds no font values,
 * so it survives a change of font untouched. `metrics` holds every value the
 * typeface dictates.
 */
export type FontConfigJson = {
  metrics: Record<SymbolFontMetric, SymbolFontMetricJson>;
  symbols: Record<string, SymbolFontMetric>;
};

export type SymbolNodeProps = {
  key?: string;
  value: string;
  /* legacy props for font resolution */
  fontSize?: FontSize;
  fontFeature?: FontFeature;
};

export type SymbolNodeConstructorProps = SymbolNodeProps;

export type SymbolSuggestionProps = {
  key: string;
};
